(function () {
    angular.module('tmx-app').factory('CreditSummaryService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportCreditSummary = exportCreditSummary;

            // function exportCreditSummary(loanapplicationnumber,branchid,nationalid) {
            function exportCreditSummary(loanapplicationnumber,culture) {
                if(!loanapplicationnumber){
                    loanapplicationnumber=null;
                }

                if(!culture){
                    culture=null;
                }

                // if(!branchid){
                //     branchid=null;
                // }
                
                // if(!nationalid){
                //     nationalid=null;
                // }

                var objArgs = {
                    "LoanApplicationNumber":loanapplicationnumber,
                    "culture":culture
                    // "BranchId":branchid,
                    // "NationalId":nationalid
                };
      
                var filters = {
                    "StoredProcedure": "sp_credit_summary",
                    "Arguments": objArgs,
                    "ReportName": "Credit_Summary",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'CreditSummary.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: "FieldName",
                    title: "FieldName",
                    type: "text",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template:"{{CreditSummaryCtrl.formatlabel(dataItem[CreditSummaryCtrl.formatColumnName('FieldName')]) }}",
                    headerTemplate: "<span>{{'FieldName'|translate}}</span>"
                },
                {
                    field: "Value",
                    title: "Value",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template:"{{dataItem[CreditSummaryCtrl.formatColumnName('Value')] }}",
                    headerTemplate: "<span>{{'Value'|translate}}</span>"
                }
            ];


            return Report;

        }]);
})();